import strings from 'utils/strings'
import {
  SMARTPLEX_INPUT,
  SMARTPLEX_OUTPUT,
  SMART_SWITCH_GROUP,
  BASE_TYPE,
  LOGIC_SET,
  NATIVE_INPUTS,
  NATIVE_OUTPUTS,
  SWITCHES,
  MODULE_TYPE_FILTER,
  INTERFACE_CONNECTOR,
  FUNCTION,
  USER,
} from 'utils/constants'

export const chipTitleByFilterType = Object.freeze({
  [SMARTPLEX_INPUT]: strings.smartplex_input,
  [SMARTPLEX_OUTPUT]: strings.smartplex_output,
  [SMART_SWITCH_GROUP]: strings.smart_switch,
  [BASE_TYPE]: strings.sp_type,
  [LOGIC_SET]: strings.logic_sets,
  [MODULE_TYPE_FILTER]: strings.module_type,
  [NATIVE_INPUTS]: strings.native_inputs,
  [NATIVE_OUTPUTS]: strings.native_outputs,
  [SWITCHES]: strings.switches,
  [INTERFACE_CONNECTOR]: strings.interface_connectors,
  [FUNCTION]: strings.function,
  [USER]: strings.features_created_by,
})
